import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2031Status: 'idle',
    startProcess2031Error: undefined as any,
    loadUserParamsProcess2031Status: 'idle',
    loadUserParamsProcess2031Error: undefined as any,

    process2031List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2031 = createAsyncThunk('process2031Slice/startProcess2031', async ({ process2031 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2031/`,
        prepareData(process2031),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2031Status } = getState().process2031Slice
        return startProcess2031Status !== 'pending'
    }
})

export const loadUserParamsProcess2031 = createAsyncThunk('process2031Slice/loadUserParamsProcess2031', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2031/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2031Status } = getState().process2031Slice
        return loadUserParamsProcess2031Status !== 'pending'
    }
})

const Process2031Slice = createSlice({
    name: 'process2031Slice',
    initialState,
    reducers: {
        resetstartProcess2031: (state) => {
            state.job = undefined
            state.startProcess2031Error = undefined
        },
        resetstartProcess2031Error: (state) => {
            state.startProcess2031Error = undefined
        },
        resetloadUserParamsProcess2031: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2031Error = undefined
        },
        resetloadUserParamsProcess2031Error: (state) => {
            state.loadUserParamsProcess2031Error = undefined
        },
        removeFromProcess2031ListById: (state, action) => {
            state.process2031List = state.process2031List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2031ListByIds: (state, action) => {
            state.process2031List = state.process2031List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2031List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2031Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2031List = []
            state.startProcess2031Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2031.pending, (state) => {
            state.startProcess2031Status = 'pending'
            state.startProcess2031Error = undefined
        })
        builder.addCase(startProcess2031.fulfilled, (state, action) => {
            state.startProcess2031Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2031.rejected, (state, action) => {
            state.startProcess2031Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2031Error = action.error.message
            } else {
                state.startProcess2031Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2031.pending, (state) => {
            state.loadUserParamsProcess2031Status = 'pending'
            state.loadUserParamsProcess2031Error = undefined
        })
        builder.addCase(loadUserParamsProcess2031.fulfilled, (state, action) => {
            state.loadUserParamsProcess2031Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2031.rejected, (state, action) => {
            state.loadUserParamsProcess2031Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2031Error = action.error.message
            } else {
                state.loadUserParamsProcess2031Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2031,
    resetstartProcess2031Error,
    resetloadUserParamsProcess2031,
    resetloadUserParamsProcess2031Error,
    removeFromProcess2031ListById,
    removeFromProcess2031ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2031Slice.actions
export default Process2031Slice.reducer
